import { useQuery } from "@tanstack/react-query";
import { useVault } from "./useVault";
import { useSession } from "../stores/session";

export function useGcStats() {
  const vault = useVault();
  const session = useSession((s) => s.session);
  return useQuery({
    enabled: !!session,
    queryKey: ["gc-stats", session?.handle] as const,
    queryFn: async () => {
      if (!session) throw new Error("no session");
      return vault.getStorageStats(session.handle);
    },
  });
}
